import React, { useState } from 'react';
import { api } from '@/lib/api';
import { User, PencilSimple } from '@phosphor-icons/react';

export function ProfileSection({ user, checkAuth }) {
  const [editing, setEditing] = useState(false);
  const [name, setName] = useState(user?.name || '');
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    setMessage('');
    try {
      await api.put('/auth/update-profile', { name });
      await checkAuth();
      setMessage('Profile updated successfully');
      setEditing(false);
    } catch (err) {
      setMessage(err.response?.data?.detail || 'Failed to update');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="bg-white border border-[#E5E7EB] rounded-lg p-6" data-testid="profile-section">
      <div className="flex items-center justify-between mb-4">
        <h2 className="font-outfit text-lg font-semibold text-[#09090B] flex items-center gap-2"><User size={20} /> Profile</h2>
        {!editing && (
          <button onClick={() => setEditing(true)} data-testid="edit-profile-button"
            className="flex items-center gap-1 px-3 py-1.5 text-sm text-[#002FA7] font-ibm font-semibold rounded-md hover:bg-[#002FA7]/5 transition-all">
            <PencilSimple size={14} /> Edit
          </button>
        )}
      </div>
      {message && <div className={`mb-4 p-3 rounded-md text-sm font-ibm ${message.includes('success') ? 'bg-green-50 border border-green-200 text-green-700' : 'bg-red-50 border border-red-200 text-red-700'}`}>{message}</div>}
      {editing ? (
        <form onSubmit={save} className="space-y-4">
          <div>
            <label className="block text-xs font-bold tracking-[0.15em] uppercase text-[#6B7280] mb-1 font-ibm">Full Name</label>
            <input data-testid="profile-name-input" type="text" value={name} onChange={e => setName(e.target.value)} required
              className="w-full px-3 py-2.5 border border-[#E5E7EB] rounded-md font-ibm text-sm focus:outline-none focus:ring-2 focus:ring-[#002FA7]" />
          </div>
          <div className="flex gap-2 justify-end">
            <button type="button" onClick={() => { setEditing(false); setName(user?.name || ''); setMessage(''); }} data-testid="cancel-profile-button"
              className="px-4 py-2 border border-[#E5E7EB] text-[#09090B] font-ibm text-sm rounded-md hover:bg-[#F3F4F6]">Cancel</button>
            <button data-testid="save-profile-button" type="submit" disabled={saving}
              className="px-4 py-2 bg-[#002FA7] text-white font-ibm text-sm font-semibold rounded-md hover:bg-[#00237D] disabled:opacity-50 transition-all">
              {saving ? 'Saving...' : 'Save'}
            </button>
          </div>
        </form>
      ) : (
        <div>
          <p className="text-xs font-bold tracking-[0.15em] uppercase text-[#6B7280] font-ibm mb-1">Full Name</p>
          <p className="font-ibm text-[#09090B]">{user?.name}</p>
        </div>
      )}
    </div>
  );
}
